import Collections from './Collections';
import Levels from './Levels';

export default { Collections, Levels };
